module.exports = __webpack_public_path__ + "img/waves-3.3cef91d4.jpg";